var tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
document.head.appendChild(tag);

function onYouTubeIframeAPIReady() {
    var player1 = new YT.Player("player", {
        height: "100%",
        width: "100%",
        videoId: "iSrRRBHWKvk",
        playerVars: {
            controls: 1
        },
        events: {
            onReady: function(e) {
                videoAutoControl(".video", e.target, 0.5);
            }
        }
    });
}

function videoAutoControl(selector, video, videoTogglePct) {
    var videoHeightPct = jQuery(selector).height() / jQuery(window).height();
    var offsetIn = (1 - videoTogglePct * videoHeightPct) * 100;
    var offsetOut = -(videoTogglePct * videoHeightPct) * 100;

    function inView(video) {
        video.playVideo();
    }

    function outView(video) {
        video.pauseVideo();
    }

    jQuery(selector).waypoint(
        function(direction) {
            if (direction == "down")
                inView(video);
            else outView(video);
        }, {
            offset: offsetIn + "%"
        }
    );

    jQuery(selector).waypoint(
        function(direction) {
            if (direction == "up")
                inView(video);
            else outView(video);
        }, {
            offset: offsetOut + "%"
        }
    );
}